import { FormsModule } from '@angular/forms';
import { AuthService } from './../services/auth.service';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { AlertComponent } from './dialogs/alert/alert.component';
import { LockHinweisComponent } from './dialogs/lock-hinweis/lock-hinweis.component';
import { LoadingComponent } from './dialogs/loading/loading.component';
import { StateService } from '../services/state.service';
import { FirebaseService } from '../services/firebase.service';
import { AuthGuard } from './auth.guard';
import { GlobalService } from '../services/global.service';
import { CallDialogComponent } from './dialogs/call-dialog/call-dialog.component';

@NgModule({
    declarations: [LoadingComponent, LockHinweisComponent, AlertComponent, CallDialogComponent],
    imports: [FormsModule, CommonModule, SharedModule],
    providers: [AuthGuard, AuthService, FirebaseService, StateService, GlobalService, DatePipe, DecimalPipe],
})
export class CoreModule {}
